/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_Login_HInputs */

const en_funnel_account_login_h = /** @type {(inputs: Funnel_Account_Login_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to start your trial`)
};

const es_funnel_account_login_h = /** @type {(inputs: Funnel_Account_Login_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para empezar tu prueba`)
};

/**
* | output |
* | --- |
* | "Sign in to start your trial" |
*
* @param {Funnel_Account_Login_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_login_h = /** @type {((inputs?: Funnel_Account_Login_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_Login_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_login_h(inputs)
	return en_funnel_account_login_h(inputs)
});